import { Component } from '@angular/core';
import { AuthService } from '@authentication/auth.service';
import { TipoSolapaRancho } from '@shared/enums/TipoSolapaRancho';
import { TipoUsuario } from '@shared/enums/tipoUsuario';

@Component({
  selector: 'app-rancho-index',
  templateUrl: './rancho-index.component.html',
  styleUrls: ['./rancho-index.component.css']
})
export class RanchoIndexComponent {

  TipoUsuario = TipoUsuario;
  TipoSolapaRancho = TipoSolapaRancho;

  constructor(public authService: AuthService) { }

  esComercial(): boolean{
   return this.authService.hasRole(TipoUsuario.COMERCIAL);
  }

  esJefeAeroplanta(): boolean{
    return this.authService.hasRole(TipoUsuario.JEFEDEAEROPLANTA);
   }

}
